import { Upload } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { RcFile } from 'antd/lib/upload';
import { clsx } from 'clsx';

import { beforeMediaUpload, beforeUpload, beforeUploadType, showAxiosError } from '@utils';
import cls from './file-upload.module.css';

interface Props {
  uploadAction: (rcFile: RcFile) => Promise<string>;
  className?: string;
  wrapperClassName?: string;
  type?: 'pdf' | 'pdf+xlsx' | 'image' | 'media';
  content?: React.ReactNode;
  size?: number;
  disabled?: boolean;
}

export const FileUpload = (
  { uploadAction, className, wrapperClassName, type, content, size, disabled }: Props,
) => {
  const [loading, setLoading] = useState(false);

  const onUpload = async (rcFile: RcFile) => {
    try {
      setLoading(true);
      const url = await uploadAction(rcFile);

      return url;
    } catch (err: any) {
      showAxiosError(err);

      return '';
    } finally {
      setLoading(false);
    }
  };

  let accept;
  if (type === 'pdf') {
    accept = 'application/pdf';
  } else if (type === 'pdf+xlsx') {
    accept = 'application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  } else if (type === 'image') {
    accept = 'image/jpeg,image/jpg,image/png';
  } else if (type === 'media') {
    accept = 'image/jpeg,image/jpg,image/png,application/pdf,video/mp4';
  }

  return (
    <div className={wrapperClassName}>
      <Upload
        listType="picture-card"
        showUploadList={false}
        beforeUpload={type === 'media' ? beforeMediaUpload :
          type ? beforeUploadType(type, size) : beforeUpload}
        customRequest={async ({ onSuccess }) => setTimeout(() => {
          onSuccess && onSuccess('ok');
        }, 0)}
        action={onUpload}
        onPreview={() => {}}
        className={clsx(cls.upload, className)}
        accept={accept}
        disabled={disabled}
      >
        <div>
          {loading ? (
            <LoadingOutlined className={cls.iconLoading} />
          ) : (
            <>
              {content ? content : <span className={clsx(cls.iconPlus, 'iconPlus')}>+</span>}
            </>
          )}
        </div>
      </Upload>
    </div>
  );
};
